// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\ManagePilotLookups\ManagePilotLookupsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';

// ManagePilotLookupsData is the class that ManagePilotLookups serializes to/from
export interface ManagePilotLookupsData {
    Id : number;
	
    Organizations : OrganizationData[] | null;
    PilotAgency : PilotAgencyData | null;
    Pilots : PilotData[] | null;
	
}

// ManagePilotLookupsOptions is the class which may be passed to the ManagePilotLookups constructor to define optional initial data values
export interface ManagePilotLookupsOptions {
    Id : number;
	
    Organizations? : OrganizationOptions[] | null;
    PilotAgency? : PilotAgencyOptions | null;
    Pilots? : PilotOptions[] | null;
	
}

export class ManagePilotLookups {
    public Id : DataSignal<number>;
	
    public Organizations : SDataArray<Organization>;
    public PilotAgency : DataSignal<PilotAgency | null>;
    public Pilots : SDataArray<Pilot>;
	

    constructor();
    constructor(data : ManagePilotLookupsOptions);
    constructor(data: ManagePilotLookupsOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Organizations = SArray<Organization>([]);
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.Pilots = SArray<Pilot>([]);
	    
    }

    static key(obj : ManagePilotLookups) {
        return obj.Id();
    }
    
    static dataKey(obj : ManagePilotLookupsOptions) {
        return obj.Id;
    }

    static update(obj : ManagePilotLookups, data : ManagePilotLookupsOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ManagePilotLookups.ts